import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {DocumentTemplateService} from '../../../services/document-template.service';

@Component({
  selector: 'app-document-template-view-modal',
  templateUrl: './document-template-view-modal.component.html',
  styleUrls: ['./document-template-view-modal.component.css']
})
export class DocumentTemplateViewModalComponent implements OnInit {

  documentTemplateDetail: any;
  idFromParent: number;

  constructor(
    private spinner: NgxSpinnerService,
    public ref: DynamicDialogRef, 
    public config: DynamicDialogConfig,
    private documentTemplateService:DocumentTemplateService,
  ) { 
    this.idFromParent = config.data.id;
  }

  ngOnInit(): void {
    this.getDocumentTemplateDetails();
  }

  getDocumentTemplateDetails()
  {
    this.documentTemplateService.getDocumentTemplateById(this.idFromParent).subscribe((data: any) => {
      this.documentTemplateDetail = data;
      console.log('this.documentTemplateDetail');
      console.log(this.documentTemplateDetail);
     });
  }

}
